'use client'

export { default } from '@/screens/dashboard/DashboardPage'
